export const TYPE_PUBLICATIONS = 'publications';
export const TYPE_INTELLECTUALS = 'intellectuals';